function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
  fill: "#FFF4B2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.6783 22.1912C34.6783 16.1042 29.5768 11.1999 23.4203 11.5361C17.9363 11.8259 13.5305 16.3245 13.3334 21.8202C13.2058 25.5419 14.9797 28.8578 17.7739 30.8636C18.9449 31.71 19.6174 33.0665 19.6174 34.5158V38.0173C19.6174 40.4404 21.5768 42.3999 24 42.3999C26.4232 42.3999 28.3826 40.4404 28.3826 38.0173V34.5158C28.3826 33.0781 29.0551 31.71 30.2145 30.8752C32.916 28.939 34.6783 25.7738 34.6783 22.1912Z",
  fill: "#17BEBB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.658 34.5158V21.2173L24 17.623L26.342 21.2173V34.5158",
  fill: "#FFE43E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6174 34.5159V38.0173C19.6174 40.4405 21.5768 42.3999 24 42.3999C26.4232 42.3999 28.3826 40.4405 28.3826 38.0173V34.5159H19.6174Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24 43.0957C21.2058 43.0957 18.9218 40.8232 18.9218 38.0174V34.5159C18.9218 33.287 18.3421 32.1275 17.3681 31.4319C14.2725 29.2058 12.5102 25.6 12.6377 21.7971C12.7305 18.9681 13.8899 16.2783 15.8957 14.2493C17.9015 12.2087 20.5565 11.0029 23.3855 10.8522C26.5392 10.6783 29.542 11.7913 31.8261 13.9594C34.1102 16.1275 35.3739 19.0609 35.3739 22.2145C35.3739 25.8667 33.6 29.3217 30.6203 31.4551C29.6464 32.1507 29.0783 33.2986 29.0783 34.5275V38.029C29.0783 40.8116 26.7942 43.0957 24 43.0957ZM24 12.2203C23.8145 12.2203 23.629 12.2203 23.4435 12.2319C18.3305 12.4985 14.1913 16.7188 14.0174 21.8435C13.9015 25.1826 15.4551 28.3478 18.1681 30.3072C19.5015 31.2696 20.3015 32.8464 20.3015 34.5275V38.029C20.3015 40.058 21.9594 41.7159 23.9884 41.7159C26.0174 41.7159 27.6754 40.058 27.6754 38.029V34.5275C27.6754 32.8464 28.4754 31.2812 29.7971 30.3188C32.4058 28.4406 33.9594 25.4145 33.9594 22.2029C33.9594 19.4319 32.858 16.8696 30.8406 14.9565C28.9971 13.1826 26.5739 12.2203 24 12.2203Z",
  fill: "#F5822A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3827 35.2116H19.629C19.2464 35.2116 18.9334 34.8986 18.9334 34.516C18.9334 34.1334 19.2464 33.8203 19.629 33.8203H28.3827C28.7653 33.8203 29.0783 34.1334 29.0783 34.516C29.0783 34.8986 28.7653 35.2116 28.3827 35.2116Z",
  fill: "#F5822A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3827 38.7131H19.629C19.2464 38.7131 18.9334 38.4 18.9334 38.0174C18.9334 37.6348 19.2464 37.3218 19.629 37.3218H28.3827C28.7653 37.3218 29.0783 37.6348 29.0783 38.0174C29.0783 38.4 28.7653 38.7131 28.3827 38.7131Z",
  fill: "#F5822A"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M26.3421 35.2114C25.9594 35.2114 25.6464 34.8984 25.6464 34.5158V21.4259L24 18.8984L22.3536 21.4143V34.5042C22.3536 34.8868 22.0406 35.1998 21.658 35.1998C21.2754 35.1998 20.9623 34.8868 20.9623 34.5042V21.2172C20.9623 21.0781 20.9971 20.9506 21.0783 20.8346L23.4203 17.252C23.5478 17.0549 23.7681 16.939 24 16.939C24.2319 16.939 24.4522 17.0549 24.5797 17.252L26.9218 20.8346C26.9913 20.9506 27.0377 21.0781 27.0377 21.2172V34.5158C27.0377 34.8984 26.7247 35.2114 26.3421 35.2114Z",
  fill: "#F5822A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M26.342 21.913H21.6696C21.287 21.913 20.9739 21.6 20.9739 21.2174C20.9739 20.8348 21.287 20.5217 21.6696 20.5217H26.342C26.7247 20.5217 27.0377 20.8348 27.0377 21.2174C27.0377 21.6 26.7247 21.913 26.342 21.913Z",
  fill: "#F5822A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M24 35.2116C23.6174 35.2116 23.3044 34.8985 23.3044 34.5159V21.2174C23.3044 20.8348 23.6174 20.5217 24 20.5217C24.3826 20.5217 24.6957 20.8348 24.6957 21.2174V34.5159C24.6957 34.8985 24.3826 35.2116 24 35.2116Z",
  fill: "#F5822A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M24 9.3101C23.6174 9.3101 23.3044 8.99705 23.3044 8.61445V5.59995C23.3044 5.21734 23.6174 4.9043 24 4.9043C24.3826 4.9043 24.6957 5.21734 24.6957 5.59995V8.60285C24.6957 8.99705 24.3826 9.3101 24 9.3101Z",
  fill: "#F5822A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9739 14.6783C36.8 14.6783 36.6145 14.6087 36.487 14.4696C36.2203 14.2029 36.2203 13.7624 36.487 13.4841L38.6087 11.3624C38.8754 11.0957 39.3159 11.0957 39.5942 11.3624C39.8609 11.629 39.8609 12.0696 39.5942 12.3479L37.4725 14.4696C37.3333 14.6087 37.1478 14.6783 36.9739 14.6783Z",
  fill: "#F5822A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0261 14.6783C10.8522 14.6783 10.6667 14.6087 10.5391 14.4696L8.41738 12.3479C8.15071 12.0812 8.15071 11.6406 8.41738 11.3624C8.68404 11.0957 9.12462 11.0957 9.40288 11.3624L11.5246 13.4841C11.7913 13.7508 11.7913 14.1913 11.5246 14.4696C11.3855 14.6087 11.2 14.6783 11.0261 14.6783Z",
  fill: "#F5822A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M9.34494 27.652H6.34204C5.95944 27.652 5.64639 27.339 5.64639 26.9564C5.64639 26.5738 5.95944 26.2607 6.34204 26.2607H9.34494C9.72755 26.2607 10.0406 26.5738 10.0406 26.9564C10.0406 27.339 9.72755 27.652 9.34494 27.652Z",
  fill: "#F5822A"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M41.658 27.652H38.6551C38.2725 27.652 37.9594 27.339 37.9594 26.9564C37.9594 26.5738 38.2725 26.2607 38.6551 26.2607H41.658C42.0406 26.2607 42.3536 26.5738 42.3536 26.9564C42.3536 27.339 42.0406 27.652 41.658 27.652Z",
  fill: "#F5822A"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5d9eac6b.svg";
export { ForwardRef as ReactComponent };